import { render, staticRenderFns } from "./AlertsView.vue?vue&type=template&id=096ae51d&scoped=true&"
import script from "./AlertsView.vue?vue&type=script&lang=js&"
export * from "./AlertsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096ae51d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('096ae51d')) {
      api.createRecord('096ae51d', component.options)
    } else {
      api.reload('096ae51d', component.options)
    }
    module.hot.accept("./AlertsView.vue?vue&type=template&id=096ae51d&scoped=true&", function () {
      api.rerender('096ae51d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/alerts/AlertsView.vue"
export default component.exports